import { CSSProperties } from "react";

export const hiddenInputStyles: CSSProperties = {
    visibility: "hidden",
    position: "absolute",
    width: "1px",
    height: "1px",
    overflow: "hidden"
};
